import React from "react";

class Forecast {
    static register = {
        VIEW_FORECAST: {slug: 'VIEW_FORECAST', render: <></>},
    };
}

export default Forecast;